import { Label, TableRowDisplayEvent } from "@mcleod/components";
import { AutogenLayoutAvailableRatewareTariffs } from "./autogen/AutogenLayoutAvailableRatewareTariffs";

export class AvailableRatewareTariffs extends AutogenLayoutAvailableRatewareTariffs {

    tableAvailableTariffsOnRowDisplay(event: TableRowDisplayEvent) {
        const labelWarning: Label = event.getTableRow().findComponentById("labelWarning") as Label;
        labelWarning.visible = (event.getTableRow().data.get("rtc_uid") == 0);
        labelWarning.tooltip = `${event.getTableRow().data.get("rateware_tariff_name")} not found in Rateware Tariff Code table.`;
    }
}
